import { RegistroContext } from 'contexts/registroContext/RegistroContext';
import { Ferramenta, RotasComBarra } from 'enum';
import {
  Button,
  Col,
  Container,
  HomeIcon,
  Row,
} from 'plataforma-fundacao-componentes';
import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { languageValues } from 'utils/LanguageUtils';
import style from './Agradecimento.scss';

const { rootClassName } = style;
const { naoEncontrado } = RotasComBarra;

export default function Agradecimento() {
  const navigate = useNavigate();
  const { state } = useContext(RegistroContext);

  useEffect(() => {
    if (!state.flow) {
      navigate(naoEncontrado, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.flow]);

  return (
    <Container verticalPadding>
      <div className={rootClassName}>
        <Row>
          <Col className={`${rootClassName}-check`} centralized>
            <svg
              width='98'
              height='98'
              viewBox='0 0 98 98'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <circle
                cx='49'
                cy='49'
                r='48'
                stroke='#3FA110'
                strokeWidth='2'
                strokeLinejoin='round'
              />
              <path
                d='M29 49.5L43.5 64L56.25 49.5L69 35'
                stroke='#3FA110'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          </Col>
        </Row>
        <Row>
          <Col className='title text-center' centralized>
            {languageValues.pages.agradecimento.title}
          </Col>
          <Col className='sub-title text-center' centralized>
            {languageValues.pages.agradecimento.subtitle}
          </Col>
          <Col buttonActionsCol centralized>
            <Button
              leftIcon={<HomeIcon />}
              onClick={() => {
                if (state.ferramenta === Ferramenta.CRESCER) {
                  window.location.replace(
                    'https://www.sicredi.com.br/site/fundacao/'
                  );
                } else {
                  navigate(-1);
                }
              }}
            >
              {languageValues.buttons.initialPage}
            </Button>
          </Col>
        </Row>
      </div>
    </Container>
  );
}
